import { cn } from '@/utils/tailwind.util';
interface MainAwardItemProps {
  title: string;
  subTitle?: string;
  description: string | React.ReactNode;
  className?: string;
  titleClassName?: string;
  iconPath: string;
}
export const MainAwardItem = ({
  title,
  description,
  className,
  subTitle,
  iconPath,
  titleClassName
}: MainAwardItemProps) => {
  return <div className={cn('flex flex-col items-center px-lg pt-2xl tablet-sm:pt-3xl pb-xl rounded-xl relative bg-violet-50 w-full tablet-sm:max-w-[300px]', className)} data-sentry-component="MainAwardItem" data-sentry-source-file="AwardItem.tsx">
      <img src={iconPath} alt={`award-${title}`} className="absolute left-1/2 top-0 size-[60px] -translate-x-1/2 -translate-y-1/2 rounded-full shadow-md tablet-sm:size-[76px]"></img>
      <div className="flex w-full flex-col items-center gap-xs">
        <div className={cn('flex flex-col items-center gap-4xs text-strong', titleClassName)}>
          <span className="text-center text-heading-xl-extrabold">{title}</span>
          {subTitle && <span className="text-center text-heading-md-bold">{subTitle}</span>}
        </div>
        <div className="text-center text-body-lg-semibold text-neutral">
          {description}
        </div>
      </div>
    </div>;
};
interface SubAwardItemProps {
  title: string;
  description: string | React.ReactNode;
  iconPath: string;
  className?: string;
}
export const SubAwardItem = ({
  title,
  description,
  iconPath,
  className
}: SubAwardItemProps) => {
  return <div className={cn('flex w-full flex-col items-center gap-xs px-md py-sm tablet-sm:max-w-[300px]', className)} data-sentry-component="SubAwardItem" data-sentry-source-file="AwardItem.tsx">
      <div>
        <img src={iconPath} alt={`award-${title}`} className="size-[50px]" />
      </div>
      <div className="flex w-full flex-col gap-3xs py-3xs">
        <div className="flex flex-col items-center gap-4xs text-default">
          <span className="text-center text-heading-md-bold">{title}</span>
        </div>
        <div className="text-center text-body-md-semibold text-neutral opacity-60">
          {description}
        </div>
      </div>
    </div>;
};